/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelection } from './bulkSelection';

/**
 * Export profiles from a saved search's result snapshot.
 */
export interface SearchExportSourceSchema {
  type?: 'search';
  search_id: string;
  bulk: BulkSelection;
}
